// import { register } from '../../module/Register/locale/register.en.js';
import { example } from '@/module/Example/locale/example.en';
// base
import { date } from '@/helper/locale/base/base_date.en.js';
import { button } from '@/helper/locale/base/base_button.en.js';
// module
import { collect_point } from '@/module/CollectPoint/locale/collectpoint.en.js';
import { contact } from '@/module/Static/ContactUs/locale/contact.en.js'
import { coupon } from '@/module/Coupon/locale/coupon.en.js';
import { creditCard } from '@/module/CreditCard/locale/creditCard.en.js';
import { deliverymethod } from '@/module/DeliveryMethod/locale/deliverymethod.en.js';
import { favorite } from '@/module/MyFavorite/locale/favorite.en.js';
import { home } from '@/module/Home/locale/home.en.js';
import { pdpa } from '@/module/Static/Pdpa/locale/pdpa.en.js'
import { profile } from '@/module/Profile/locale/profile.en.js';
import { shoppingcart } from '@/module/ShoppingCart/locale/shoppingcart.en.js';
import { login } from '@/module/Login/locale/login.en.js';
import { register } from '@/module/Register/locale/Register.en.js';
import { crownpoint } from '@/module/CrownPoint/locale/crownpoint.en.js';
import { tierlevel } from '@/module/TierLevel/locale/tierlevel.en.js';
import productDetail from '@/module/Product/locale/productDetail.en';
import myOrder from '@/module/MyOrder/locale/myOrder.en';
import { mycoupon } from '@/module/MyCoupon/locale/mycoupon.en.js';
import { store } from '@/module/Store/locale/store.en.js';
import { earnpoint } from '@/module/EarnPoint/locale/earnpoint.en.js';
import { info } from '@/module/Info/locale/info.en.js';
import { subscription } from './module/subscription/subscription.en';


export const en = {
    example: example,
    // base
    date,
    button,
    // module
    collect_point,
    contact: contact,
    coupon: coupon,
    creditCard: creditCard,
    deliverymethod:deliverymethod,
    favorite: favorite,
    home: home,
    pdpa: pdpa,
    profile: profile,
    shoppingcart: shoppingcart,
    login: login,
    register: register,
    crownpoint:crownpoint,
    tierlevel: tierlevel,
    productDetail,
    myOrder,
    mycoupon: mycoupon,
    store: store,
    earnpoint: earnpoint,
    info: info,
    subscription: subscription,

    confirm_redeem: {
        confirm: "Confirm",
        cancel: "Cancel",
        please_confirm_1: 'Please confirm to use',
        please_confirm_2: 'Crowns to redeem this privilege',
        after_confirm_1: "After confirmation of redemption the privileges will be retained",
        after_confirm_2: '"My coupon"',
        after_confirm_3: "if you don't use it right away.",

        headline: 'Confirm',
        default: 'Confirm to redeem',
        defualt_have_time: 'Serial will available for {0} after confirm',
        delivery: 'Please enter shipping information to redeem',
        free: 'Serial will available for {0} after confirm',
        free_no_timer: 'Confirm to redeem',
        free_delivery: 'Please enter shipping information to redeem',
        draw: 'Confirm to join campaign <br/> Winner will be announced after {0}',
        draw_delivery: 'Please enter shipping information to redeem',
        deal: 'Serial will available for {0} after confirm',
        deal_no_timer: 'Confirm to redeem',
        deal_delivery: 'Please enter shipping information to redeem',
        buy: 'Confirm to purchase',
        buy_delivery: 'Please enter shipping information to buy',
        interface: 'This will redirect to website after confirm',

        subscription_please_confirm_1: 'Please confirm to use ',
        subscription_please_confirm_2: 'THB redeem this privilege',
        subscription_after_confirm_1: "After confirmation of redemption the privileges will be retained",
        subscription_after_confirm_2: '"My coupon"',
        subscription_after_confirm_3: "if you don't use it right away.",
    },
    redeem_button: {
        default: 'Get coupon',
        buy: 'Buy Now',
        none: '',
        soldOut: 'Sorry, This reward is reaching redemption limit.',
        soldOutBuy: 'Sorry, This reward is reaching redemption limit.',
        maxPerPerson: 'Sorry, You have already redeemed this reward.',
        redeemCoolDown: 'This campaign has been used for this period.',
        nextDate: '<br/>at : ',
        exceedBuyPointLimitPerday: '',
        conditionIsInvalid: 'This campaign requires user action before redemption, please review the conditions first.',
        campaignExpired: 'Campaign has expired.',
        campaignExpiredBuy: 'Campaign has expired.',
        campaignNotAvailable: 'Sorry. This reward is not available',
        campaignNotAvailableBuy: 'Sorry. This product is not available',
        notEnoughPoint: 'Your point are not enough to redeem this campaign.',
        notSupport: 'This campaign is not support.',
        redeem_noti_btn: 'Click to redeem your reward!',
        already_buy: 'You already buy this subscription package.',
        reward_noti: 'Get Coupon',
    },
    purchase: {
        show_code: 'View Code',
        code_expired: 'Expire',

        delivery: 'Product will be mailed based on Campaign Condition.',
        shipped: 'The Product has been delivered.',
        parcel_no: 'ParcelNo',

        not_draw1: 'Not yet drawn,',
        not_draw2: 'please check back at a later date',
        draw_winner1: 'You are the winner',
        draw_winner2: '',
        draw_not_win1: 'Sorry you are not the winner,',
        draw_not_win2: 'better luck next',
    },
    serial: {
        close_btn: 'Close',
        default_privilege_message: 'As design',
        show_code_at_shop: 'Show the code below to our staff',

        delivery: 'Product will be mailed based on Campaign Condition.',

        draw: 'Thank you for joining us.<br/>Winner will be announced after {0}',
        draw_after: 'after',

        qr_code: 'QR code',
        barcode: 'Barcode',
        code: 'Code',

        copy_code: 'copy code',
        copied: 'copied',

        expire_in: 'Expire in : ',
        code_expired: 'This serial has expired.',
        min: 's',

        redeem_on: 'Redeem on :'
    },
    shipping: {
        headline_Add: "Address",
        headline_select: "Select address",
        headline_edit: "Edit Address",
        headline_add: "Add new address",
        headline_choose_location: "Choose location",
        headline: 'Shipping address',

        search_your_location: "Search your location",
        select_location: 'Select this location',
        add_new_address: 'Add new address',

        // firstname: {
        //     name: 'Firstname',
        //     placeholder: 'Firstname',
        //     required: 'Please enter firstname',
        //     too_short: '',
        //     invalid: '',
        // },
        // lastname: {
        //     name: 'Lastname',
        //     placeholder: 'Lastname',
        //     required: 'Please enter lastname',
        //     too_short: '',
        //     invalid: '',
        // },
        addressName: {
            name: 'Name address',
            placeholder: 'Name address',
            required: 'Please enter address name',
            too_short: '',
            invalid: '',
        },
        building: {
            name: 'Address Detail',
            placeholder: 'Address Detail',
            // required: 'Please enter address detail',
            required: '',
            too_short: '',
            invalid: '',
        },
        address: 'Address',

        isDefaultAddress: 'Select as default',
        defaultAddress: 'Default',
        save_address: 'Save address for next privilege',
        save_address_buy: 'Save address for next puchase',

        confirm_btn: 'Confirm',
        cancel_btn: 'Cancel',
        save_btn: 'Save',

        default: 'Default',
        delete: 'Delete',

        alert_headline: 'Shipping address',
        alert_ok_btn: 'OK',

        confirm_delete_msg: 'Please confirm to delete address',
        confirm_ok_btn: 'Confirm',
    },
    tax: {
        headline_tax: "Tax invoice",
        headline_edit: "Edit Tax invoice",
        headline_add: "Add new tax invoice",
        btn_add_tax: 'Add new tax invoice',
        btn_add_tax_address: 'Add new tax invoice',
        tax_notfound: 'There is no tax invoice yet.',
        modal_del_msg: 'Do you want to delete this {0} tax address',
        confirm_del_btn: 'Confirm',
        please_fill_out: 'Please fill out all information',
        address_tax: 'Tax Invoice Address',
        companyName: {
            name: 'full Name/Company Name',
            placeholder: 'full Name/Company Name',
            required: 'Please fill full Name/Company Name',
            too_short: '',
            invalid: '',
        },
        nationalid: {
            name: 'Tax ID',
            placeholder: 'Tax ID',
            required: 'Please enter Tax ID',
            too_short: 'Tax ID number must be {0} digits',
            invalid: '',
        },
        contactnumber: {
            name: 'Mobile No.',
            placeholder: 'Mobile No.',
            required: 'Mobile No.',
            too_short: 'Mobile No must be {0} digits',
            invalid: 'Incorrect Mobile No format',
        },
        building: {
            name: 'Details',
            placeholder: 'Details',
            required: '',
            too_short: '',
            invalid: '',
        },
        zipcode: {
            name: 'Postcode',
            placeholder: 'Postcode',
            required: 'Please enter postcode',
            too_short: 'Postcode must be {0} digits',
            invalid: 'Invalid postcode',
        },
        subdistrict: {
            name: 'Sub district',
            placeholder: 'Please selece sub-district',
            required: 'Please selece sub-district',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'District',
            placeholder: 'Please selece district',
            required: 'Please selece district',
            too_short: '',
            invalid: '',
        },
        province: {
            name: 'Province',
            placeholder: 'Please selece province',
            required: 'Please selece province',
            too_short: '',
            invalid: '',
        },

        taxpayer_id: 'Taxpayer ID',
        mobile_no: 'Mobile No.',
        default_address: 'Default',
        delete_address: 'Delete',
        isDefaultTax: 'Set as default',
        save: 'Save'
    },
    main: {
        home_page: "Home",
        login: "Login",
        campaign: "Campaign",
        category: 'Category',
        map: "Map",
        terms: "Terms And Conditions",
        history: 'History',
        profile: "Profile",
        logout: "Logout",
        lang: "Language",
        msgLogout: "Logout ?",
        cancel: "Cancel",

        greeting1: 'Good Morning,',
        greeting2: 'Good Afternoon,',
        greeting3: 'Good Afternoon,',
        greeting4: 'Good Evening,',
        guest: 'Guest',
        signin: 'Sign in/ Create Account',

        bath: 'Baht',
        select: 'Select',

        menubar: {
            home: 'Home',
            reward: 'Rewards',
            earn_point: 'Earn point',
            my_order: 'My order',
            more: 'More',
            bk_app: 'BK  Thailand  Application',
            download: 'ดาวน์โหลดเลย!',
            download2: 'Download',
            catering: 'Catering',

        }
    },
    campaign: {
        baht: 'Baht',
        point: 'Crowns',
        get_point: 'Get ',
        use_point: 'Use ',
    },
    detail: {
        detail: 'Detail',
        condition: 'Condition',

        relate_reward: 'Relate rewards',

        more_detail: 'More details',
        point_unit: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Use Point : ',
        available_date: 'Date',
        expire_date: 'Expire date : {0}',

        color: {
            name: 'Color',
            placeholder: 'Please select color',
            required: 'Please select color',
        },
        size: {
            name: 'Size',
            placeholder: 'Please select size',
            required: 'Please select size',
        },

        confirm_coupon: {
            expire_on: 'Coupon will be expire on :',
            use_now: 'Use now',
            add_to: 'Add to "My coupon"'
        },

        warnning_guest_1: "Sorry, this reward is for members only.",
        warnning_guest_2: "Please login or register",
        view_detail: "View Detail",
    },
    history: {
        title: 'Point history',
        earn: 'Earn',
        redeem: 'Redeem',
        expire: 'Expire',

        expire_on: 'Expire on :',
        status: 'Status :',
        view_code: 'View code',

        point: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Used point : ',

        parcel_number: 'Parcel No. : ',

        monthPicker: {
            name: 'Month/Year',
            placeholder: '',
            required: 'Please select month/year',
            too_short: '',
            invalid: '',
            month: {
                name: '',
                placeholder: 'Month',
                required: ' '
            },
            year: {
                name: '',
                placeholder: 'Year',
                required: ' '
            },
        },

        expire_text: 'You crowns will not count towards the Whopper level on',
        crowns: 'crowns',

        traces_msg: "Congratulations! You've received {0} welcome crowns!",
        used: 'Used',
    },
    title: "BURGER KING® Thailand - Great flame-grilled burgers with fresh ingredients, Whopper, Burger King Delivery, Burger King 1112",
    error_user_delete: "Your user account has been deleted and will be eligible to sign up again within 30 days",
    error_mantain: "Due to application improvements Please logout and Login again To update system information",
    cookie: {
        cookie_text: "Burger King uses cookies on this website. By continuing to browse this site, you agree to its use. To learn more, please click on",
        privacy: "privacy policy",
        accept_cookie: "Accept",
    },
    error_delivery: {
        delivery: "Delivery order will be available soon!",
        instore: "In-store order will be available soon!",
    },
    consent: {
        terms: 'Terms & Conditions',
        privacy: 'Privacy policy',
        marketing: 'Marketing Consent',
        accept: 'Accept',
        mkt_desc: 'I am interested in and would like to receive information about products, services, free gifts, discounts, promotions and other relevant activities from Burger King and ',
        mkt_desc2: 'affiliated companies and relevant brands',
        tab_to_button: 'Tab to bottom',
    }

};
